<div class="small-dialog-container">
  <payee-icon
    name="delivery"
    class="dialog-icon"
    width="80"
    height="80"
  ></payee-icon>

  <h1 class="title">
    {{ "WORKFLOW_DIALOGS.BAILIFF_DELIVERY_FEE_TRANSFER.TITLE" | translate }}
  </h1>

  <div class="description">
    {{ "WORKFLOW_DIALOGS.BAILIFF_DELIVERY_FEE_TRANSFER.DESCRIPTION" | translate }}
  </div>

  <div class="delivery-fee">
    {{ "WORKFLOW_DIALOGS.BAILIFF_DELIVERY_FEE_TRANSFER.AMOUNT" | translate }}:
    {{ data.delivery_fee.amount | currency: data.delivery_fee.currency_iso : "symbol-narrow" : "1.0" : "hu" }}
  </div>

  <form
    class="copy-form"
    [formGroup]="form"
  >
    <payee-form-field width="max">
      <span payee-label>
        {{ "WORKFLOW_DIALOGS.BAILIFF_DELIVERY_FEE_TRANSFER.BENEFICIARY_LABEL" | translate }}
      </span>
      <payee-copy-form-field formControlName="account_holder_name"></payee-copy-form-field>
    </payee-form-field>
    <payee-form-field width="max">
      <span payee-label>
        {{ "WORKFLOW_DIALOGS.BAILIFF_DELIVERY_FEE_TRANSFER.ACCOUNT_NUMBER_LABEL" | translate }}
      </span>
      <payee-copy-form-field formControlName="account_number"></payee-copy-form-field>
    </payee-form-field>
    <payee-form-field width="max">
      <span payee-label>
        {{ "WORKFLOW_DIALOGS.BAILIFF_DELIVERY_FEE_TRANSFER.REFERENCE_LABEL" | translate }}
      </span>
      <payee-copy-form-field formControlName="reference"></payee-copy-form-field>
    </payee-form-field>
  </form>

  <button
    mat-dialog-close
    payee-button
    width="max"
    height="tall"
  >
    <div class="arrow-button flex vcenter hcenter">
      <span>
        {{ "WORKFLOW_DIALOGS.BAILIFF_DELIVERY_FEE_TRANSFER.CLOSE" | translate }}
      </span>
      <payee-icon name="arrow-right-white"></payee-icon>
    </div>
  </button>
</div>
